import React, { Component } from "react";
import PropTypes from "prop-types";
import { StaticRouter, BrowserRouter } from "react-router-dom";

import AppContent from "./AppContent";

export default class App extends Component {
  static propTypes = {
    location: PropTypes.any,
    context: PropTypes.any,
    isBrowser: PropTypes.bool,
    sheetsRegistry: PropTypes.any,
    sheetsManager: PropTypes.any,
    generateClassName: PropTypes.any,
  };

  render() {
    const { location, context, isBrowser, sheetsRegistry, sheetsManager, generateClassName } = this.props;

    return isBrowser ? (
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    ) : (
      <StaticRouter
        location={location}
        context={context}
      >
        <AppContent sheetsRegistry={sheetsRegistry} sheetsManager={sheetsManager} generateClassName={generateClassName} />
      </StaticRouter>
    );
  }
}
